export default {"src":"/_next/static/media/dropComingSoon.70ec6a79.svg","height":205,"width":318};